import { render, staticRenderFns } from "./blacklistDisposal.vue?vue&type=template&id=13d7a65a&scoped=true"
import script from "./blacklistDisposal.vue?vue&type=script&lang=js"
export * from "./blacklistDisposal.vue?vue&type=script&lang=js"
import style0 from "./blacklistDisposal.vue?vue&type=style&index=0&id=13d7a65a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7a65a",
  null
  
)

export default component.exports